import styled from 'styled-components';
import color from 'tinycolor2';

export const ErrorPageWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 20px;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    padding: 10px;
  }
`;

export const ErrorPageContent = styled.div`
  margin: auto;
  max-width: 460px;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ErrorPageIcon = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: ${(props) => color(props.theme['color.primary']).setAlpha(0.2).toString()};
  color: ${(props) => props.theme['color.primary']};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 16px;

  > svg {
    width: 62px;
    height: 62px;
    displaY: block;
  }
`;

export const ErrorPageTitle = styled.h1`
  font-size: 32px;
  font-weight: 600;
  line-height: 1;
  color: ${(props) => props.theme['color.text.title']};
  margin: 0 0 16px;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    font-size: 28px;
  }
`;

export const ErrorPageMessage = styled.p`
  font-size: 18px;
  font-weight: 400;
  line-height: 1.4;
  color: ${(props) => props.theme['color.text.body']};
  margin: 0 0 20px;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    font-size: 16px;
  }
`;
